import { Link } from "react-router-dom";
import { SectionHeader } from "../shared/SectionHeader";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

export function SupportSafety() {
  return (
    <>
      <SectionHeader
        title="Support & Safety"
        description="Help, data export, and account protection."
      />
      <Card className="bg-card border-border mb-4">
        <CardHeader>
          <h3 className="text-[14px] font-semibold text-foreground">Contact ReviewBoost Support</h3>
          <p className="text-[12px] text-muted-foreground">Monday–Friday, 08:00–17:00 CAT. Average response: under 4 hours.</p>
        </CardHeader>
        <CardContent className="flex gap-2">
          <Button variant="outline" size="sm" asChild>
            <a href="mailto:support@reviewboost24.com">Email Support</a>
          </Button>
          <Button variant="outline" size="sm" asChild>
            <a href="https://wa.me/260970000000" target="_blank" rel="noopener noreferrer">WhatsApp Support</a>
          </Button>
        </CardContent>
      </Card>
      <Card className="bg-card border-border mb-4">
        <CardHeader>
          <h3 className="text-[14px] font-semibold text-foreground">User Guide</h3>
        </CardHeader>
        <CardContent>
          <Button variant="outline" size="sm" asChild>
            <Link to="/user-guide">Open User Guide →</Link>
          </Button>
        </CardContent>
      </Card>
      <Card className="bg-card border-border">
        <CardHeader>
          <h3 className="text-[14px] font-semibold text-foreground">Suspicious Activity</h3>
          <p className="text-[12px] text-muted-foreground">Revoke all sessions and change your password in Security.</p>
        </CardHeader>
        <CardContent>
          <Button variant="outline" size="sm" asChild>
            <Link to="/settings/security">Go to Security →</Link>
          </Button>
        </CardContent>
      </Card>
    </>
  );
}
